import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const AdminPanel = () => {
  const [banners, setBanners] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/banner_image_list"
      );
      setBanners(response.data.data);
    };

    fetchData();
  }, []);

  const deleteUser = async (userId) => {
    try {
      const response = await axios.post(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/delete_banner_image",
        { ban_id: userId },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status === true) {
        setBanners((prevUser) =>
          prevUser.filter((user) => user.ban_id !== userId)
        );
        toast.error(response.data.message || "Data Deleted Successfully!");
        navigate("/Master/Banner");
      } else {
        toast.error(response.data.error || "Delete failed.");
      }
    } catch (error) {
      console.error("There was an error!", error);
      toast.error("Failed to delete Unit.");
    }
  };

  return (
    // <div className="container mt-5">
    //   <table className="table table-bordered table-striped">
    //     <thead className="table-dark">
    //       <tr>
    //         <th colSpan="4" className=" text-center bg-white fs-4 text-black">
    //           Banner Table
    //         </th>
    //       </tr>
    //       <tr>
    //         <th className="text-white">Banner Image</th>
    //         <th className="text-white">Action</th>
    //       </tr>
    //     </thead>
    //     <tbody>
    //       {banners.map((banner, index) => (
    //         <tr key={index}>
    //           <td>
    //             <img
    //               src={`https://cyberathon.com/silverapartment/${banner.banner_img}`}
    //               alt="Banner"
    //               style={{ width: "100px", height: "auto" }}
    //             />
    //           </td>
    //           <td>
    //             <Link to={`/view-banner/${banner.ban_id}`}>
    //             <button
    //               className="btn btn-info btn-sm me-1"
    //             >
    //               <i className="fa-regular fa-eye text-white"></i>
    //             </button>
    //             </Link>
    //             <Link to={`/update-banner/${banner.ban_id}`}>
    //               <button className="btn btn-primary btn-sm me-1">
    //                 <i className="fa-regular fa-pen-to-square text-white"></i>
    //               </button>
    //             </Link>
    //           </td>
    //         </tr>
    //       ))}
    //     </tbody>
    //   </table>
    // </div>

    <div className="container mt-5">
          <h2 className="mb-4">Banner Details</h2>
    
          {banners.map((banner, index) => (
            <div key={index} className="border rounded p-4 mb-4 shadow-sm bg-light">
              <div className="d-flex justify-content-end">
                <Link to={`/update-banner/${banner.ban_id}`}>
                  <button className="btn btn-primary btn-sm me-2">
                   <i className="fa-regular fa-pen-to-square text-white" /> Edit
                  </button>
                </Link>
              </div>
              <img src={`https://cyberathon.com/silverapartment/${banner.banner_img}`} width={300}/>
              <br/>
              <br/>
              {/* <p>{banner.web_title}</p>
              <p>{banner.wed_subtitle}</p> */}
            </div>
          ))}
        </div>
  );
};

export default AdminPanel;
